<template>
  <div class="row border-bottom">
    <validation-provider rules="required" :name="_id" v-slot="{ valid, errors }" class="col-md-2 col-sm-6">
      <b-form-group id="input-group-3" label="Name" label-for="input-3">
        <b-form-input
          id="input-1"
          type="text"
          :state="errors[0] ? false : valid ? true : null"
          v-model="name"
        ></b-form-input>
      </b-form-group>
    </validation-provider>

    <b-form-group id="input-group-3" label="Qty" label-for="input-3" class="col-md-1 col-sm-2">
      <b-form-input id="input-1" type="text" v-model="qty"></b-form-input>
    </b-form-group>

    <b-form-group id="input-group-3" label="Length" label-for="input-3" class="col-md-1 col-sm-2">
      <b-form-input id="input-1" type="text" v-model="length"></b-form-input>
    </b-form-group>

    <b-form-group id="input-group-3" label="Width" label-for="input-3" class="col-md-1 col-sm-2">
      <b-form-input id="input-1" type="text" v-model="width"></b-form-input>
    </b-form-group>

    <b-form-group id="input-group-3" label="Height" label-for="input-3" class="col-md-1 col-sm-2">
      <b-form-input id="input-1" type="text" v-model="height"></b-form-input>
    </b-form-group>

    <b-form-group label="Remarks" class="col-md-2">
      <b-form-textarea id="textarea-small" size="sm" v-model="remark"></b-form-textarea>
    </b-form-group>

    <button
      type="button"
      class="btn btn-icon btn-light btn-sm mx-3 align-self-center"
      @click="removeItem"
      v-b-tooltip.hover
      title="Delete row"
    >
      <span class="svg-icon svg-icon-md svg-icon-danger">
        <!--begin::Svg Icon-->
        <inline-svg src="/media/svg/icons/General/Trash.svg"></inline-svg>
        <!--end::Svg Icon-->
      </span>
    </button>
  </div>
</template>

<script>
import { toRefs } from "@vue/composition-api";
import { ValidationProvider } from "vee-validate";

export default {
  name: "AddItemForm",
  components: {
    ValidationProvider
  },
  props: {
    item: Object
  },
  setup(props, { emit }) {
    const item = toRefs(props.item);

    const removeItem = function() {
      emit("item-remove");
    };

    return {
      _id: item._id,
      name: item.name,
      qty: item.qty,
      length: item.length,
      width: item.width,
      height: item.height,
      remark: item.remark,

      removeItem: removeItem
    };
  }
};
</script>
